// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__TbAfT","medium":"styles_medium__2ZtCP","darkMode":"styles_darkMode__QSLo4","iframeDarkMode":"styles_iframeDarkMode__Oj5eM"};